import { useLocation } from "react-router-dom";

export default function CustoPorUso() {
  const { search } = useLocation();
  const src = `/custo-por-uso.html${search || ""}`;
  return (
    <div style={{ position: "fixed", inset: 0, background: "#fff", zIndex: 40 }}>
      <iframe
        title="Custo por uso"
        src={src}
        style={{ width: "100%", height: "100%", border: "none", display: "block" }}
        data-testid="custo-por-uso-iframe"
      />
    </div>
  );
}
